var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCheckbox',{attrs:{"label":`isSelected = ${_vm.isSelected}`,"checked":_vm.isSelected},on:{"change":function($event){_vm.isSelected = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }